module.exports = __webpack_public_path__ + "img/porto-9.efb042d8.png";